import "bootstrap/dist/css/bootstrap.min.css";
import ListGroup from "react-bootstrap/ListGroup";
import { Container, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";

import Main from "../components/layout/Main";
import Header from "../components/layout/Header";

import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { DatePicker, Space } from "antd";
import React, { useState, useEffect } from "react";
import { get } from "../Libraries/Ajax/HttpService";
import { Spin, Tag, Checkbox, Radio } from "antd";
import { DownOutlined } from "@ant-design/icons";
// import Multiselect from 'multiselect-react-dropdown';
import back from "../assets/images/back.svg";
import { useDistrict } from "../utils/DistrictContext";
import dayjs from "dayjs";
function Alerts() {
  var mcdata = JSON.parse(localStorage.getItem("MCData"));
  // let history = useHistory();
  const navigate = useNavigate();
  const { RangePicker } = DatePicker;
  // const [first, setFirst] = useState(false);
  const [data, setData] = useState([]);
  const [datastatus, setDatastatus] = useState([]);
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const selectedDistrict = useDistrict();
  const onRedirection = (event) => {
    // history.push('/dashboard');
    // window.history.back();
    navigate(-1);
  };
  const handleOutlierpageclick = () => {
    navigate("/outliers");
  };
  const handleNotificationclick = () => {
    navigate("/alert#/action-2");
  };
  const handleNotificationpageclick = () => {
    navigate("/notificationss");
  };

  // useEffect(() => {
  //   var user = JSON.parse(localStorage.getItem("MCData"));
  //   var userid = user?.userid;
  //   if (first === false) setLoading(true);
  //   get(`apis/notification_status_list?user_id=${userid}`).then((response) => {
  //     console.log(response);
  //     setData(response.data.data.meter_status_list_not_good);
  //     const numAscending = [...data].sort((a, b) => b.impact - a.impact);
  //     setDatastatus(numAscending);
  //     setDatas(response.data.data.meter_status_list_good);
  //     setFirst(true);
  //     setLoading(false);
  //   });
  // }, [first]);

  useEffect(() => {
    if (!selectedDistrict) return;

    const user = JSON.parse(localStorage.getItem("MCData"));
    const userid = user?.userid;
    const district = selectedDistrict?.selectedDistrict;
    setLoading(true);

    get(
      `apis/notification_status_list?user_id=${userid}&district=${district}`
    )
      .then((response) => {
        const notGood = response.data.data.meter_status_list_not_good || [];
        const good = response.data.data.meter_status_list_good || [];

        // sort by impact (descending)
        const numAscending = [...notGood].sort((a, b) => b.impact - a.impact);

        setData(notGood);
        setDatastatus(numAscending);
        setDatas(good);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [selectedDistrict]);

  return (
    <>
      {/* <head>
        <title>
          {" "}
          {window.location.href.indexOf("mizuwatch.com") > -1
            ? "MizuWatch"
            : "MizuSmart"}{" "}
        </title>
      </head> */}
      <Header />
      <Main>
        {/* <div className="d-flex fs-30 gap-3">
                    <ArrowLeftOutlined onClick={onRedirection} />
                    <h3 className="mb-0">Notification</h3>
                </div> */}
        {/*  */}
        <div className="d-flex align-items-center mb-4">
          {/* <ArrowLeftOutlined onClick={onRedirection} /> */}
          <img
            src={back}
            alt=""
            style={{ width: "10px", cursor: "pointer" }}
            onClick={onRedirection}
          />
          {/* <h3 className="mb-0 ms-3">Notification</h3> */}
          <div className="d-flex align-items-center">
            <div
              className="new-box-padding  text-blue  align-self-center c-pointer "
              style={{ borderBottom: "2px solid #1998f0", borderRadius: "0" }}
              onClick={handleNotificationclick}
            >
              Notification
            </div>
            {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
              ""
            ) : (
              <>
                <div
                  className=""
                  style={{ width: "2px", height: "25px", background: "#ccc" }}
                ></div>

                <div
                  className="new-box-padding   align-self-center c-pointer "
                  style={{
                    borderBottom: "2px solid #ccc",
                  }}
                  onClick={handleNotificationpageclick}
                >
                  Reports and Alerts
                </div>
              </>
            )}

            <div
              className=""
              style={{ width: "2px", height: "25px", background: "#ccc" }}
            ></div>
            <div
              className="new-box-padding   align-self-center c-pointer "
              style={{
                borderBottom: "2px solid #ccc",
              }}
              onClick={handleOutlierpageclick}
            >
              Data Outliers
            </div>
          </div>
        </div>
        {/*  */}
        <div className="bottom-layout">
          <Container className="p-4">
            {loading === false ? (
              <>
                <Row>
                  {datastatus.map((variant, idx) => (
                    <>
                      <div className="col-lg-12 mb-4">
                        <Card
                          className="h-100"
                          style={{
                            border: "0",
                            borderBottom: "1px solid #edf0f5",
                            borderRadius: "0",
                          }}
                        >
                          <Card.Body>
                            <div className="d-flex align-items-end justify-content-between mb-3">
                              <Card.Subtitle
                                className="mb-0 text-black"
                                style={{ fontSize: "15px" }}
                              >
                                {variant.overided_name}
                              </Card.Subtitle>
                              {variant.register_number ? (
                                <Card.Subtitle
                                  className="mb-0 text-black"
                                  style={{ fontSize: "15px" }}
                                >
                                  {variant.meter_id}-{variant.register_number}
                                </Card.Subtitle>
                              ) : (
                                <Card.Subtitle
                                  className="mb-0 text-black"
                                  style={{ fontSize: "15px" }}
                                >
                                  {variant.meter_id}
                                </Card.Subtitle>
                              )}
                            </div>
                            {variant.status?.map((item, index) => (
                              <>
                                {
                                  // item.toLowerCase().includes('leak detected') ?
                                  variant.impact <= 0.2 ? (
                                    <Card.Text className="alertbadge w-100">
                                      {" "}
                                      <span className="">{item}</span>
                                      <br />
                                    </Card.Text>
                                  ) : variant.impact <= 0.4 &&
                                    variant.impact > 0.2 ? (
                                    <Card.Text className="alertbadgess w-100">
                                      {" "}
                                      <span>{item}</span>
                                      <br />
                                    </Card.Text>
                                  ) : (
                                    <Card.Text className="alertbadges w-100">
                                      {" "}
                                      <span>{item}</span>
                                      <br />
                                    </Card.Text>
                                  )
                                }
                              </>
                            ))}
                          </Card.Body>
                        </Card>
                      </div>
                    </>
                  ))}

                  <br />
                  {/* <hr /> */}

                  <div className="col-lg-12 mb-4">
                    <Card className="h-100 p-2 border-0">
                      {datas && datas.length > 0 ? (
                        <Card.Header
                          className="mb-2 alertbadgee"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                          }}
                        >
                          Meters below have no issues reported.
                        </Card.Header>
                      ) : data.length === 0 ? (
                        <Card.Header
                          className="mb-2 yellownoti"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                          }}
                        >
                          No Meters Are Currently Being Monitored.
                        </Card.Header>
                      ) : (
                        <></>
                      )}

                      <ListGroup variant="flush">
                        {datas.map((variant, idx) => (
                          <>
                            <div className="px-3 d-flex align-items-end justify-content-between mb-2 borderstylealert">
                              <Card.Text className="w-50">
                                {variant.account_name}
                              </Card.Text>
                              {variant.register_number ? (
                                <Card.Text className="w-50 text-end">
                                  {variant.meter_id}-{variant.register_number}
                                </Card.Text>
                              ) : (
                                <Card.Text className="w-50 text-end">
                                  {variant.meter_id}
                                </Card.Text>
                              )}
                              <br />
                            </div>
                          </>
                        ))}
                      </ListGroup>
                    </Card>
                  </div>
                </Row>
              </>
            ) : (
              <div className="examples">
                <Spin size="large" />
              </div>
            )}
          </Container>
        </div>
      </Main>
    </>
  );
}

export default Alerts;
